import { render, staticRenderFns } from "./mail-reply-modal.vue?vue&type=template&id=881c62ec&scoped=true&"
import script from "./mail-reply-modal.vue?vue&type=script&lang=js&"
export * from "./mail-reply-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881c62ec",
  null
  
)

export default component.exports